import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { loadScheduleEpic } from './_epics/loadSchedule.epic';
import { loadScheduleListEpic } from './_epics/loadScheduleList.epic';
import { createScheduleEpic } from './_epics/createSchedule.epic';
import { updateScheduleEpic } from './_epics/updateSchedule.epic';
import { removeScheduleEpic } from './_epics/removeSchedule.epic';
import { exportSchedulesEpic } from './_epics/exportSchedules.epic';

export const scheduleEpic = safeCombineEpics(
  loadScheduleEpic,
  loadScheduleListEpic,
  createScheduleEpic,
  updateScheduleEpic,
  removeScheduleEpic,
  exportSchedulesEpic,
);
